<template>
		<div id="email-match" class="container-h-xl container-v-md">
			<dd-form
          v-if="matchState !== undefined"
          class="form"
          @submit="handleMatchEmail"
          :hideButtons="!hasSelectedCustomer"
      >
					<dd-step title="Zoek een klant" class="flex-col">
            <DetailedCustomerSelectComponent
              @input="handleSelectedCustomer"
            />
            <div v-if="!hasSelectedCustomer" class="flex-row align-items-center justify-content-end mt-lg">
              <dd-button disabled class="color-white">Volgende</dd-button>
            </div>
					</dd-step>

					<dd-step title="E-mail koppelen" :cols="1">
						<div class="flex-col gap-md">
              <div v-if="matchState === MatchStateEnum.SINGLE" class="couple-row">
                <div class="width-stretch flex-row justify-content-end align-items-center">
                  <p>E-mail opslaan als</p>
                </div>
                  <dd-input v-if="firstSelectedEmail" v-model="firstSelectedEmail.name"></dd-input>
              </div>
              <div v-if="matchState === MatchStateEnum.SINGLE && hasAttachments" class="couple-row">
                  <dd-switch v-model="attachAttachments" style="place-self: flex-start"></dd-switch>
                <div>
                  <p>Bijlagen apart opslaan</p>
                  <div v-if="attachAttachments">
                    <div
                      class="flex-row align-items-center mt-sm gap-sm"
                      v-for="(attachment,index) in attachments"
                      :key="index"
                    >
                      <dd-switch v-model="attachment.should_import" :checked="true"></dd-switch>
                      <dd-input class="width-stretch" v-model="attachment.filename"></dd-input>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="notOutbox" class="couple-row">
                <dd-switch data-dusk="process-mail" v-model="processMail" :checked="true"></dd-switch>
                <p>E-mail naast koppelen ook verwerken</p>
              </div>
            </div>

            <AttachableCategorySelect                
                :customer="selectedCustomer"
                @input="handleAttachableCategoryChange"
            />

					</dd-step>
			</dd-form>

      <create-task-modal
          id="create-task-dialog"
          :visible="showCreateTaskDialog"
          @cancel="hideCreateTaskDialog"
          description="Je hebt een e-mail gekoppeld. Wil je hiervoor een taak aanmaken?"
          :customerId="createTaskCustomerId"
          :category="createTaskCategory"
      />
      <navigate-to-customer-modal
          id="match-success-dialog"
          :visible="showNavigateToCustomerDialog !== null"
          :instanceType="showNavigateToCustomerDialog && showNavigateToCustomerDialog.instanceType"
          :instanceId="showNavigateToCustomerDialog && showNavigateToCustomerDialog.instanceId"
          @cancel="hideNavigateToCustomerDialog"
          :customerId="selectedCustomer && selectedCustomer.id"
      />

		</div>
</template>

<script>
import EmailApi from "~/api/email";
import CustomerUtil from "~/util/customer";
import AttachableCategoryApi from "~/api/attachable_category";
import AccountStateEnum from "../../enums/AccountStateEnum";
import MatchStateEnum from "../../enums/MatchStateEnum";
import AttachableCategorySelect from "~/pages/components/attachable_category/AttachableCategorySelectComponent.vue"
import DetailedCustomerSelectComponent from "~/pages/components/customer/DetailedCustomerSelectComponent.vue";
import NavigateToCustomerModal from '~/pages/components/modal/dialog/NavigateToCustomerModal';
import {mapGetters, mapActions} from "vuex";
import CreateTaskModal from "~/pages/components/modal/dialog/CreateTaskModal.vue";
import {CategoryEnum} from "~/enums";

export default {
  name: "MatchComponent.vue",
  components:{
    CreateTaskModal,
    NavigateToCustomerModal,
    DetailedCustomerSelectComponent,
    AttachableCategorySelect
  },
  data(){
		return{
      selectedCustomer: undefined,
      selectedCategory: undefined,
      attachAttachments: false,
			processMail: true,
			defaultAttachableCategory: {},
      showNavigateToCustomerDialog: null,
      showCreateTaskDialog: false,
      createTaskCustomerId: undefined,
      createTaskCategory: CategoryEnum.CUSTOMER,
		}
  },
  computed: {
    ...mapGetters('email', [
        "firstSelectedEmail",
        "selectedEmails",
        "accountState",
        "matchState",
        "isCustomerPage"
    ]),    
    MatchStateEnum(){
      return MatchStateEnum;
    },
    hasSelectedCustomer(){
      return this.selectedCustomer !== undefined;
    },
    attachments(){
      return this.firstSelectedEmail?.attachments || [];
    },
    hasAttachments(){
      return this.attachments.length > 0;
    },
    transformDefaultAttachableCategory(){
      return {
        ...this.defaultAttachableCategory,
        category: {
          id: this.defaultAttachableCategory.id,
          template: false
        },
        customer_id: this.selectedCustomer?.id,
        id: this.selectedCustomer?.id,
        type: 'customer'
      };
    },
    fullName() {
      return ( this.hasSelectedCustomer ) ? CustomerUtil.getFullName(this.selectedCustomer) : '';
    },
    notOutbox(){
      return this.accountState != AccountStateEnum.OUTBOX;
    }
  },
	methods:{
    ...mapActions('email', [
      "setMatchState",
      "loadEmails",
      "goBack"
    ]),
    async handleSelectedCustomer(selected){
      if ( selected !== this.selectedCustomer ){
        this.$set(this, 'selectedCustomer', selected);
        if ( this.selectedCustomer?.id ){
          this.defaultAttachableCategory = await AttachableCategoryApi.getCategoryForCustomerByName( this.selectedCustomer?.id, 'E-mail' );
          this.processMail = true;
        }
      }
    },
    async handleMatchEmail(){

      const selectedCategory = this.selectedCategory || this.transformDefaultAttachableCategory;

      const data = {
        customerId: selectedCategory.customer_id,
        isTemplate: selectedCategory.category.template,
        attachableCategoryId: selectedCategory.category.id,
        instanceId: selectedCategory.id,
        instanceType: selectedCategory.type,
        processEmail: this.notOutbox ? this.processMail : false,
        attachAttachments: this.attachAttachments,
      };

      const {data: response} = ( this.matchState === MatchStateEnum.SINGLE) ? await this.matchSingle(data) : await this.matchMultiple(data);

      if ( response.success ){
        this.loadEmails();
        this.$set(this.firstSelectedEmail, 'customer_id', this.selectedCustomer?.id);
        this.$notification['success']({
          message: `De e-mail${this.matchState === MatchStateEnum.MULTIPLE ? 's zijn' : ' is'} succesvol gekoppeld.`,
        });
        this.showCreateTaskDialog = true;
        this.createTaskCustomerId = selectedCategory.customer_id;
      } else {
        this.$notification['error']({
          description: 'Er ging iets verkeerd tijdens het koppelen. Probeer het opnieuw'
        });
      }

    },
    matchSingle(data){
      data.emailId = this.firstSelectedEmail.id;
      data.name = this.firstSelectedEmail.name;
      data.attachments = this.attachments.map(attachment => ({
        name: attachment.filename,
        should_import: attachment.should_import
      }));
      return EmailApi.matchEmail(this.firstSelectedEmail.id, data);
    },
    matchMultiple(data){
      data.attachments = [];
      data.emailIds = [];
      data.names = [];
      data.attachments = {};
      this.selectedEmails.map( email => {
        data.emailIds.push(email.id);
        data.names.push(email.name);
        data.attachments[email.id] = email.data.attachments.map(attachment => ({
          name: attachment.filename,
          should_import: attachment.should_import
        }));
      })
      return EmailApi.matchMultipleEmails(data);
    },
    handleAttachableCategoryChange(category){
      this.selectedCategory = category;
    },
    resetForm(){
      this.customer_last_name = '';
      this.customer_initials = '';
      this.foundCustomers = [];
      this.selectedCustomer = undefined;
      this.selectedCategory = undefined;
      this.processMail = true;
    },
    hideCreateTaskDialog(preventGoBack){
      this.showCreateTaskDialog = false;
      if (preventGoBack) return;
      if (this.isCustomerPage) {
        this.navigator.back();
      } else {
        const selectedCategory = this.selectedCategory || this.transformDefaultAttachableCategory;
        this.showNavigateToCustomerDialog = {
          instanceType: selectedCategory.type,
          instanceId: selectedCategory.id,
        };
      }
    },
    hideNavigateToCustomerDialog(){
      this.showNavigateToCustomerDialog = null;
      if (this.matchState === MatchStateEnum.MULTIPLE) this.goBack();
      this.setMatchState( undefined );
    }
  },
  watch:{
    matchState(){
      if ( this.matchState === undefined) this.resetForm();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/_default.scss";
.couple-row{
	display: flex;
	flex-direction: row;
	align-items: center;
}
.couple-row>*:nth-child(1){
	flex: 0.3;
	display: flex;
	justify-content: flex-end;
	margin-right: $spacing-md;
}
.couple-row>*:nth-child(2){
  flex: 0.7;
}
p{
	margin: 0;
}
</style>
<style lang="scss">
@import "~@/_default.scss";
.form>.main-form{
	height: auto;
}
.show-black-text label {
  color: $color-black !important;
  font-weight: 400 !important;
}
.radio-buttons > *:nth-child(odd){
  background-color: $main-content-bg-color;
}
</style>
